import React, { FunctionComponent } from 'react';
import { TooltipTypes } from '../../../../types/data';
import './index.scss';

interface SideViewTooltipComponentProps {
  tooltipPosition: TooltipTypes.TooltipPosition;
  tooltipOpacity: number;
  tooltipData: TooltipTypes.TooltipDataUnit[];
}

const SideViewTooltipComponent: FunctionComponent<SideViewTooltipComponentProps> = (props) => {
  const { tooltipPosition, tooltipOpacity, tooltipData } = props

  // console.log('in SideViewTooltipComponent, tooltipData: ', tooltipData)
  // console.log('in SideViewTooltipComponent, tooltipPosition: ', tooltipPosition)
  // console.log('in SideViewTooltipComponent, tooltipOpacity: ', tooltipOpacity)
  return (
    <div className='tooltip' style={{
      left: tooltipPosition.left,
      top: tooltipPosition.top,
      opacity: tooltipOpacity,
      zIndex: tooltipOpacity === 0 ? -10:10,
    }} >
        {tooltipData.map((dataUnit, index) => {
          const attributeName = Object.keys(dataUnit)[0]; // 获取键名
          const value = dataUnit[attributeName]; // 获取对应的值

          return (
            <React.Fragment key={index}>
              <div className='tooltip-title'>{attributeName}</div>
              <div className='tooltip-content'>{value}</div>
            </React.Fragment>
          );
        })}
    </div>
  )
}

export default SideViewTooltipComponent